import styled from "@emotion/styled"

export const Container = styled.div`
  ul {
    padding-left: 16px;
    border-left: 1px solid black;
  }
`
